<template>
	<div class="mx-3">
		<BackHeader class="mb-4" @onBackClicked="onBackClicked">Back to payment options</BackHeader>
		<div class="title">Stripe Account Information</div>
		<div class="row-lg mt-4">
			<div class="col-lg-4">
<!--				<div class="subtitle pb-2">Stripe Account Integration</div>-->
				<div>
					Here is the information about your connected Stripe account
				</div>

			</div>
			<div class="col">
				<div class="card py-4 px-4 qwoach-form">

					<el-form :model="paymentIntegrationItemData" :rules="rules" ref="mainForm">

<!--						<FormTextRow-->
<!--							prop="email"-->
<!--							:showDivider="false"-->
<!--							:isVertical="true"-->
<!--							title="PayPal account email"-->
<!--							v-model="paymentIntegrationData.email"/>-->
						<FormTextRow
							v-if="paymentIntegrationItemData.stripeEmail"
							prop="clientId"
							:showDivider="false"
							:isVertical="true"
							:disabled="isIntegrated"
							title="Stripe Email"
							v-model="paymentIntegrationItemData.stripeEmail"/>
						<FormTextRow
							prop="secret"
							:showDivider="false"
							:isVertical="true"
							:disabled="isIntegrated"
							title="Stripe Account Id"
							v-model="paymentIntegrationItemData.stripeUserId"/>
					</el-form>
				</div>

				<div class="mt-4 ml-4" v-if="!isIntegrated">
					<el-button type="primary" size="small" @click="onConnectPressed">Connect</el-button>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import FormTextRow from "@/core/components/Form/FormTextRow.vue";
	import BasePaymentIntegrationView from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/BasePaymentIntegrationView.vue";
	import BackHeader from "@/core/components/BackHeader.vue";
	import StripeIntegrationItem from "@shared/Billing/StripeIntegrationItem";

	export default {
		name: "StripePaymentIntegration",
		extends: BasePaymentIntegrationView,
		components: {BackHeader, FormTextRow},

		data: () => ({
			rules:{
				clientId: [
					{
						required: true,
						whitespace: false,
						message: "Client id can't be empty",
						trigger: 'validate'
					},
				],
				secret: [
					{
						required: true,
						whitespace: false,
						message: "Secret can't be empty",
						trigger: 'validate'
					},
				],
			}
		}),

		methods: {
			createPaymentIntegrationItem(){
				return new StripeIntegrationItem()
			},

			validateIntegration(paymentIntegrationItem) {
				return this.$dataManager.apiPostPayPalIntegrationValidate(paymentIntegrationItem)
			}
		},

		computed: {
			isIntegrated(){
				return this.paymentIntegrationItemData.integrated()
			}
		}

	}
</script>

<style>

</style>
